import { ref } from 'vue';

const currentPopupId = ref<symbol | null>(null);

export function registerPopup(id: symbol) {
  currentPopupId.value = id;
}

export function isCurrentPopup(id: symbol): boolean {
  return currentPopupId.value === id;
}

export function unregisterPopup(id: symbol) {
  if (currentPopupId.value === id) currentPopupId.value = null;
}

export { currentPopupId };
